import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Vale from './Vales';
import { ValesData } from '../../types/Types';

interface Props {
  valesPreAct: ValesData[];
  retrieveValesAhorro: any;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setPromocion: React.Dispatch<React.SetStateAction<boolean>>;
  isMobile: boolean;
}

const ValesPreActivados: FC<Props> = ({
  valesPreAct,
  retrieveValesAhorro,
  setVisible,
  isMobile,
  setPromocion,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="divider" />
      <div className="listado-vales">
        <h2 className="bloque-datos__title u-text-brand">
          <span className="divider__square brand-color" />
          <span className="u-margin-right">{t('vales.preactivados')}</span>
        </h2>
        <div className="listado-vales__filtro" />
      </div>

      <div className="listado-vales-promociones listado-vales__activos">
        {valesPreAct.map((valeData, index) => (
          <Vale
            preActivado
            key={`vale-${valeData.valeEAN}`}
            data={valeData}
            cargarVales={retrieveValesAhorro}
            valeIndex={isMobile ? 0 : index}
            showCondLegales={setVisible}
            setPromocion={setPromocion}
          />
        ))}
      </div>
    </>
  );
};

export default ValesPreActivados;
